module.exports = function mailTemplate(order, ) {

	const productDictionary = window.productDictionary;
	const DEFAULT_TYPES = {
		kafa_u_zrnu: 'Kafa u zrnu',
		kafa_mlevena_za_espresso_moka_pot: "Kafa mlevena za espresso/moka pot",
		kafa_mlevena_za_papirni_filter: "Kafa mlevena za papirni filter",
		kafa_mlevena_za_metalni_filter: "Kafa mlevena za metalni filter",
		kafa_mlevena_za_french_press_cafetiere: "Kafa mlevena za French press/Cafetiere",
		fino_sitno_mlevena_kafa: "Fino/sitno mlevena kafa",
	}

	const {user, products} = order;
	const {full_name, email, adress, phone} = user;

	var orderItems = '';
	var total = 0;
	for (var key in products) {
		const {qty, type, price} = products[key];
		let productId = key;
		total = total + price;
		let productType = type === null ? '' : DEFAULT_TYPES[type];
		orderItems = orderItems +
			`<tr>
				<td style="text-align: left;">${productDictionary[productId].productName}</td>
				<td style="text-align: left;">${productType}</td>
				<td style="text-align: left;">${qty}</td>
				<td style="text-align: left;">${productDictionary[productId].pricePerKg}</td>
				<td style="text-align: left;">${price}</td>
			</tr>`
		;
	}
	return (
		`<h2>Podaci narucioca</h2>
		<table style="width:auto;">
			<tr>
				<th style="text-align: left;">Ime i prezime:</th>
				<td>${full_name}</td>
			</tr>
			<tr >
				<th style="text-align: left;">Adresa:</th>
				<td>${adress}</td>
			</tr>
			<tr>
				<th style="text-align: left;">Telefon:</th>
				<td>${phone}</td>
			</tr>
			<tr>
				<th style="text-align: left;">Email:</th>
				<td>${email}</td>
			</tr>
		</table>
		<br>
		<h2>Podaci porudzbine</h2>
		<table style="width:auto">
			<tr>
				<th style="text-align: left; min-width:80px">Naziv</th>
				<th style="text-align: left; min-width:80px">Tip</th>
				<th style="text-align: left; min-width:80px">Kolicina</th>
				<th style="text-align: left; min-width:80px">Cena (kg)</th>
				<th style="text-align: left; min-width:80px">Cena</th>
			</tr>
			${orderItems}
			<tr>
				<td colspan="5" style="text-align: end; border-top: 1px solid #000;">Ukupno: ${parseFloat(total).toFixed(2)} RSD</td>
			</tr>
		</table>`
	)
}
